<app-loader *ngIf="isLoading"></app-loader>
<div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
    <div>
        <h4 class="q-heading">
            <span><img src="../../../assets/images/backarrow.png" (click)="goBack()" alt=""
                    class="me-2 cursor-pointer" /></span>
            {{ "MANAGEDEVICE.SYNCSCORE" | translate }}
        </h4>
    </div>

    <div class="ms-auto">
        <form [formGroup]="restorePublishForm">
            <select class="form-select bg-transparent" formControlName="mobileDeviceName"
                (change)="onMobileDeviceSelect($event)">
                <option *ngFor="let item of mobileDevice" [value]="item.id">
                    {{ item.deviceName }}
                </option>
            </select>
        </form>
    </div>
</div>


<div class="commandsBG-WHITE mb-5 mb-md-0 text-center">
    <div class="row">
        <div class="col-md-12 mb-3">
            <img src="./assets/images/SYNCDEVICEILL.png" alt="" class="w-200" />
        </div>

        <div>
            
                <p>
                    <strong>{{ "MANAGEDEVICE.SYNCSCORE" | translate }}</strong>
                </p>
            
        </div>
        <ul class="list-unstyled">
          
            <li>
            
                <span>
                    {{ "MANAGEDEVICE.SYNCTHEDEVICESCORE" | translate }}
                </span>
            </li>
        </ul>
    </div>

    <div class="row mb-0 mb-md-5">
        <div class="col-md-12">
            <button type="button" class="submit-btn bg-orgclr shadow-none me-3 w-auto" (click)="sendCommand()">
                {{ "MANAGEDEVICE.SYNCNOW" | translate }}
            </button>
        </div>
        <div class="col-md-12 text-center mt-2">
            <app-last-updated-on [deviceId]="deviceId" [requestType]="SCORE"></app-last-updated-on>
        </div>
    </div>
</div>

<div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto" id="ScorePopup"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
    aria-hidden="true">
    <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
        <div
            class="modal-content border-none shadow-lg px-4 relative pointer-events-auto rounded-25 bg-white outline-none">
            <ng-container *ngIf="!isLock">
                <div class="mt-4">
                    <img src="./assets/images/sync.svg" alt="" class="mx-auto" />
                </div>
                <h4 class="q-modal-heading mt-2 fw-bold">
                    {{ "MANAGEDEVICE.SYNCINITIATED" | translate }}
                </h4>
                <div class="text-center mb-4 mt-3 d-flex justify-content-center">
                    <div class="me-3">
                        <button type="button" class="submit-btn bg-orgclr" data-bs-dismiss="modal">
                            {{ "MANAGEDEVICE.DONE" | translate }}
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>